import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseUserAwareness from '../../AbstractObjects/GatewayPlan/InnerPages/BaseUserAwareness';

const pageSchema = PlanGetSchema.pages.userAwareness;
const pageId = pageSchema.pageId;

function PlanUserAwareness({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseUserAwareness
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanUserAwareness;